import ModalArea from 'components/layout/ModalArea';
import { useLocalObservable } from 'mobx-react-lite';
import { createContext, useContext } from 'react';
import { LayoutStore } from 'stores/LayoutStore';

const layoutStoreContext = createContext<LayoutStore>({} as LayoutStore);

export const ProvideLayout = ({ children }: any) => {
  const store = useLocalObservable(() => new LayoutStore());

  return (
    <layoutStoreContext.Provider value={store}>
      {children}

      <ModalArea />
    </layoutStoreContext.Provider>
  );
};

export const useLayoutStore = () => {
  return useContext(layoutStoreContext);
};
